import { render } from "./TramiteFormCarga.vue?vue&type=template&id=e98c9644&scoped=true"
import script from "./TramiteFormCarga.vue?vue&type=script&lang=js"
export * from "./TramiteFormCarga.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=1&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=2&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=3&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=4&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=5&id=e98c9644&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=6&id=e98c9644&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98c9644"]])

export default __exports__